import React from 'react';
import { useTheme } from '@mui/material/styles';
import Styled from './OberthurCard.style';

const OberthurCard = () => {
  const theme = useTheme();

  return (
    <Styled theme={theme}>
      <img className="chip" src="/assets/images/credit-card.svg" alt="Chip" />
      <img className="logo" src="/assets/images/card-logos/oberthur.svg" alt="Logo" />
    </Styled>
  );
};

export default OberthurCard;
